// src/i18n.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpBackend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

// قراءة اللغة المحفوظة من localStorage قبل التهيئة
const getStoredLanguage = () => {
  try {
    const stored = localStorage.getItem('i18nextLng');
    if (stored && (stored === 'ar' || stored === 'en')) {
      return stored;
    }
  } catch {
    // ignore storage errors
  }
  return 'ar'; // Default to Arabic if no stored language
};

i18n
  .use(HttpBackend) // Load translations from public folder
  .use(LanguageDetector) // Detect browser language
  .use(initReactI18next)
  .init({
    lng: getStoredLanguage(), // Use stored language or default to Arabic
    fallbackLng: 'ar',
    debug: false,
    backend: {
      loadPath: '/translations/{{lng}}/{{ns}}.json',
    },
    ns: ['global', 'delivery', 'posKitchen', 'landing', 'pos', 'hr', 'reservationsDept', 'callCenter', 'warehouse'],
    defaultNS: 'global',
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng',
    },
    interpolation: {
      escapeValue: false, // React already escapes by default
    },
  });

// ✅ Set direction and lang after initialization
i18n.on('initialized', () => {
  const lng = i18n.language;
  const dir = lng === 'ar' ? 'rtl' : 'ltr';
  document.documentElement.setAttribute('dir', dir);
  document.documentElement.setAttribute('lang', lng);
  
  // Update axios default headers
  updateAxiosHeaders(lng);
});

// ✅ Also update if language changes dynamically
i18n.on('languageChanged', (lng) => {
  const dir = lng === 'ar' ? 'rtl' : 'ltr';
  document.documentElement.setAttribute('dir', dir);
  document.documentElement.setAttribute('lang', lng);
  
  // حفظ اللغة في localStorage تلقائياً
  try {
    localStorage.setItem('i18nextLng', lng);
  } catch {
    // ignore storage errors
  }
  
  // Force re-render of components
  window.dispatchEvent(new CustomEvent('languageChanged', { detail: { language: lng, direction: dir } }));
  
  // Update axios default headers
  updateAxiosHeaders(lng);
});

// Function to update axios headers
const updateAxiosHeaders = (language) => {
  // Import axios dynamically to avoid circular dependencies
  import('axios').then(({ default: axios }) => {
    axios.defaults.headers.common['Accept-Language'] = language;
    axios.defaults.headers.common['lang'] = language;
  });
};

export default i18n;
